import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../../core/services/api-endpoint.service';
import { ITrackingResult } from '../../../models/shipments/tracking/tracking-result.interface';
import { ITrackingScan } from '../dialog/models/tracking-scan.interface';

@Injectable({ providedIn: 'root' })
export class TrackingScanService {
    public constructor(private readonly http: HttpClient,
                       private readonly apiEndpointService: ApiEndpointService,
    ) {
    }

    public getTrackingDetails(shipmentId: string, shipmentType?: string): Observable<ITrackingResult> {
        const params = {
            shipmentid: shipmentId,
            shipmenttype: shipmentType || 'web',
        };

        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getTrackingDetails'))
            .query(params)
            .toString();
        return this.http.get<ITrackingResult>(endpoint)
                   .pipe(
                       map((result) => {
                               result.Scans = result.Scans.map((scan) => {
                                   scan.StatusTypeCode = this.refineStatusTypeCode(scan.StatusTypeCode);
                                   return scan;
                               });

                               return result;
                           },
                       ));
    }

    public getTrackingScans(trackingNumber: string): Observable<ITrackingScan[]> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getTrackingScans'))
            .param('trackingNumber', trackingNumber)
            .toString();

        return this.http.get<ITrackingScan[]>(endpoint)
                   .pipe(
                       map(scans => {
                           return scans.map((scan) => {
                               scan.statusTypeCode = this.refineStatusTypeCode(scan.statusTypeCode);
                               return scan;
                           });
                       }),
                   );
    }

    public refineStatusTypeCode(statusTypeCode: string): string {
        const originalStatusTypeCode = statusTypeCode?.toLowerCase();
        const isInTransit = !['d', 'm', 'x'].includes(originalStatusTypeCode);
        if (isInTransit) {
            return 'i';
        }

        return originalStatusTypeCode;
    }
}
